import React, {useState, useEffect} from 'react';
import styled from 'styled-components';

const Container = styled.div`
  position: relative;
  margin-bottom: 32px;
`;

export const AutoHeightParent = ({children, childRef, className}) => {
  const [childHeight, setChildHeight] = useState(0);

  useEffect(() => {
    const updateHeight = () => {
      if (childRef.current) {
        const observer = new ResizeObserver(entries => {
          for (let entry of entries) {
            setChildHeight(entry.target.offsetHeight);
          }
        });

        observer.observe(childRef.current);

        return () => {
          observer.unobserve(childRef.current);
        };
      }
    };

    updateHeight(); // Update height on mount

    window.addEventListener('resize', updateHeight); // Update on window resize

    return () => {
      window.removeEventListener('resize', updateHeight);
    };
  }, []);

  return (
    <Container className={className} style={{height: childHeight + 'px'}}>
      {children}
    </Container>
  );
};